import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('invite_your_team_member_rganisation_companyname'),
    addComment: defineMessage('add_comment'),
    inviteUsers: defineMessage('invite_users'),
    descriptionTextNoInviteMessage: defineMessage('the_following_users_wil_o_join_the_organisation'),
    descriptionText: defineMessage('add_a_welcome_message_f__email_this_is_optional'),
};
